'use client';

import { useCallback, useMemo } from 'react';
import { useViewportWidthClassType } from '@ui/shared/ViewportSizeProvider/ViewportSizeProvider';
import { FrontendBroker, FrontendLoad } from '@trucksmarter/shared';
import PublicLoadTable from './PublicLoadTable';
import DallasText from '@ui/Dallas/Text/DallasText';
import BrokersProvider from '@ui/shared/BrokersProvider/BrokersProvider';
import LoadGridList from '../../../../../../(authenticated)/(carrier)/(marketplace)/(loads)/loadboard/_ui/LoadGridList/LoadGridList';

export interface Props {
  className?: string;
  loads: FrontendLoad[];
  broker: FrontendBroker;
}

export default function PublicLoadBoardResponsiceResults({
  className,
  loads,
  broker,
}: Props) {
  const viewportWidthClassType = useViewportWidthClassType();
  const brokers = useMemo(() => ({ [broker.broker]: broker }), [broker]);
  const onLoadClick = useCallback(
    (load: FrontendLoad) => window?.open(`/load/${load.id}/public`, '_blank'),
    [],
  );

  return viewportWidthClassType === 'compact' ? (
    <BrokersProvider value={brokers}>
      <LoadGridList
        className={className}
        loads={loads}
        onLoadClick={onLoadClick}
        emptyStateContent={
          <>
            <DallasText variant="headerRegularL">No available loads</DallasText>
            <DallasText color="darkGray">
              There are no available loads to display
            </DallasText>
          </>
        }
      />
    </BrokersProvider>
  ) : (
    <PublicLoadTable
      className={className}
      loads={loads}
      broker={broker}
      onLoadClick={onLoadClick}
    />
  );
}
